/* =====================================================================
   Smooth open/close animation for FAQ accordions on the collapsible-content
   section. Overrides native <details> instant close with a height + opacity
   transition. Duration reads from --faq-anim-duration CSS variable.
   ===================================================================== */
(function () {
  'use strict';

  function init() {
    const accordions = document.querySelectorAll('.collapsible-content details');
    if (!accordions.length) return;

    accordions.forEach(setupAccordion);

    // Reinitialise when Shopify theme editor injects new sections
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (e) {
        e.target.querySelectorAll('.collapsible-content details').forEach(setupAccordion);
      });
    }
  }

  function setupAccordion(details) {
    if (details.dataset.smoothToggle === 'true') return;
    details.dataset.smoothToggle = 'true';

    const summary = details.querySelector('summary');
    if (!summary) return;

    // Wrap the non-summary children in a container we can measure and animate
    let contentWrap = details.querySelector('[data-faq-content]');
    if (!contentWrap) {
      contentWrap = document.createElement('div');
      contentWrap.setAttribute('data-faq-content', '');
      contentWrap.style.overflow = 'hidden';
      contentWrap.style.height = details.open ? 'auto' : '0';
      contentWrap.style.opacity = details.open ? '1' : '0';

      const children = Array.from(details.children).filter(function (n) { return n !== summary; });
      children.forEach(function (n) { contentWrap.appendChild(n); });
      details.appendChild(contentWrap);
    }

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      const duration = getDuration(details);

      if (details.open) {
        // Closing
        contentWrap.style.height = contentWrap.scrollHeight + 'px';
        contentWrap.getBoundingClientRect(); // force reflow
        requestAnimationFrame(function () {
          contentWrap.style.transition = 'height ' + duration + 'ms cubic-bezier(0.4, 0, 0.2, 1), opacity ' + Math.round(duration * 0.7) + 'ms ease';
          contentWrap.style.height = '0';
          contentWrap.style.opacity = '0';
        });
        window.setTimeout(function () {
          details.open = false;
          contentWrap.style.transition = '';
        }, duration);
      } else {
        // Opening
        details.open = true;
        contentWrap.style.transition = '';
        contentWrap.style.height = '0';
        contentWrap.style.opacity = '0';
        contentWrap.getBoundingClientRect(); // force reflow
        const target = contentWrap.scrollHeight;
        requestAnimationFrame(function () {
          contentWrap.style.transition = 'height ' + duration + 'ms cubic-bezier(0.4, 0, 0.2, 1), opacity ' + Math.round(duration * 0.7) + 'ms ease';
          contentWrap.style.height = target + 'px';
          contentWrap.style.opacity = '1';
        });
        window.setTimeout(function () {
          contentWrap.style.height = 'auto';
          contentWrap.style.transition = '';
        }, duration);
      }
    });
  }

  function getDuration(el) {
    const style = getComputedStyle(el);
    const cssVar = style.getPropertyValue('--faq-anim-duration').trim();
    if (!cssVar) return 300;
    const match = cssVar.match(/^(\d+)/);
    return match ? parseInt(match[1], 10) : 300;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();